
<div style="margin: 0px;">
  <form [formGroup]="myForm" (ngSubmit)="onSubmit()"  novalidate>


    <div class="flex-container">

      <div>
        <mat-card style="width: 350px; height: 100%;">
          <mat-toolbar color="primary" class="mat-elevation-z16">
            <mat-toolbar-row>
              <span>{{title_text}}</span>
            </mat-toolbar-row>
          </mat-toolbar>


          <mat-card-content >



            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Client Name:</mat-label>
              <input matInput type="text" placeholder="e.g. foo" (focus)="onFocus()" formControlName="name">
              <mat-error style="font-size: 12px">Valid name required</mat-error>
            </mat-form-field>
            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Client Slug:</mat-label>
              <input matInput type="text" placeholder=" e.g. foo@bar.com" (focus)="onFocus()" formControlName="client_slug">
              <mat-error style="font-size: 12px">Valid slug required</mat-error>
            </mat-form-field>
            <mat-form-field style="margin-top: 15px; width: 100%">
              <mat-label>Client ID:</mat-label>
              <input matInput type="text" placeholder=" e.g. 1" (focus)="onFocus()" formControlName="client_id">
              <mat-error style="font-size: 12px">Valid integer id required</mat-error>
            </mat-form-field>


          </mat-card-content>
          @if (is_form_error) {
            <div>
              <mat-error style="margin-bottom: 5px">
                <strong>{{form_error_message}}</strong>
              </mat-error>
            </div>
          }


          <div class="flex-container" style="margin-top: 10px;">
            <button mat-raised-button color="primary" [disabled]="!myForm.valid || is_loading" type="submit" style="margin: 15px">{{submit_text}}</button>
            <button mat-raised-button color="accent" [disabled]="is_loading" type="button" (click)="onCancel()" style="margin: 15px">Cancel</button>
          </div>

          @if (is_loading) {
            <mat-progress-bar mode="indeterminate" style="margin-top: 10px"></mat-progress-bar>
          }
        </mat-card>
      </div>
    </div>

  </form>
</div>
